<template>
  <div style="position: relative;">
    <img :src="payBgImage" alt="" style="width: 100%;display: block;" />

    <div style="position: absolute; top: 0;left: 0;right: 0;bottom: 0;display: flex;flex-direction: column;align-items: center;justify-content: center;">
         <div style="display: flex">
            <img :src="payLockImage" alt="" class="icon" />
            <div class="title">
                <div>
                  <span>{{ L("本文未完，本篇为") }}</span>
                  <span style="color: #C18D30;">{{ L('VIP文章') }}</span>
                </div>
                <div>
                  <span>{{ L('限时免费') }}</span>
                </div>
            </div>
        </div>

        <div class="button-group">
          <div class="button primary" @click="$emit('unlock')">{{ L("立即解锁") }}</div>
        </div>

    </div>


  </div>

</template>

<script>
import payBgImage from '../../assets/pay-bg.png'
import payLockImage from '../../assets/pay-lock.png'

export default {

props: {
item: {
type: Object,
default: '',
}
},

data() {
return {
payBgImage,
payLockImage,
}
},

methods: {



}
}
</script>

<style scoped>

.icon {
width: 48px; margin-right: 24px; display: block;
}

.title {
display: flex;flex-direction: column;justify-content: space-around;font-weight: bold;
}

.button-group {
gap: 24px;
margin-top: 40px;
}

.button {
cursor: pointer;
line-height: 36px;
border-radius: 100px;
text-align: center;
border: 1px solid #C18D30;
color: #C18D30;
padding: 0 2em;
font-size: 14px;
}

.primary {
background-color: #C18D30;
color: #fff;
}


@media screen and (max-width: 768px) {

.icon {
margin-right: 12px;
width: 32px;
}
.title {
font-size: 14px;
}

.button-group {
gap: 12px;
margin-top: 12px;
}

.button {
line-height: 24px;
padding: 0 1em;
font-size: 12px;
}
}

</style>



// WEBPACK FOOTER //
// src/views/expert-details/unlock.vue